import React from 'react'
import './KRSerpLoading.css'

function KRSerpLoading() {
  return (
    <div className='loader' style={{background: '#ffa516'}}></div>
  )
}

export default KRSerpLoading